import { graphql } from "react-relay";

export const RevokeUserApiKeysMutation = graphql`
  mutation RevokeUserApiKeysMutation($input: RevokeUserAPIKeysInput!) {
    revokeUserAPIKeys(input: $input) {
      problems {
        message
      }
      revokedKeys {
        id
        identity
        revokedAt
      }
    }
  }
`;
